import { TabKey } from '@/generated/graphql';
import { type Component } from 'vue';
import {
	ProjectTabBudgetBreakdown,
	ProjectTabBudgetBurnUp,
	ProjectTabBudgetProfit,
	ProjectTabBudgetQuotedVsActual,
	ProjectTabBudgetForecast,
	ProjectTabCalendar,
	ProjectTabComments,
	ProjectTabDetails,
	ProjectTabFinances,
	ProjectTabTasksGantt,
	ProjectTabTasksList,
	ProjectTabTime,
	ProjectTabResourcePlanning,
	ProjectTabEventList,
	ProjectTabTaskBoard,
	ProjectTabBudgetHealth,
} from './tabs';

type TabConfig = {
	component?: Component;
	icon: string;
	link?: string;
	parent?: TabKey;
};

export const PROJECT_TABS: Record<TabKey, TabConfig> = {
	Tasks: { icon: 'icon-task-16' },
	Budget: { icon: 'icon-paper-coins-16' },
	Time: { component: ProjectTabTime, icon: 'icon-clock-16', link: '/time' },
	Finances: {
		component: ProjectTabFinances,
		icon: 'icon-paper-coins-16',
		link: '/finances',
	},
	Details: {
		component: ProjectTabDetails,
		icon: 'icon-paper-16',
		link: '/details',
	},
	ResourcePlanning: {
		component: ProjectTabResourcePlanning,
		icon: 'icon-person-16',
		link: '/resourcePlanning',
	},
	Comments: {
		component: ProjectTabComments,
		icon: 'icon-chat-16',
		link: '/comments',
	},
	TasksList: {
		component: ProjectTabTasksList,
		icon: 'icon-list-16',
		link: '/taskList',
		parent: TabKey.Tasks,
	},
	TasksGantt: {
		component: ProjectTabTasksGantt,
		icon: 'icon-phase-16',
		link: '/gantt',
		parent: TabKey.Tasks,
	},
	TaskBoard: {
		component: ProjectTabTaskBoard,
		icon: 'icon-board-16',
		link: '/taskBoard',
		parent: TabKey.Tasks,
	},
	EventList: {
		component: ProjectTabEventList,
		icon: 'icon-date-16',
		link: '/eventList',
		parent: TabKey.Tasks,
	},
	Calendar: {
		component: ProjectTabCalendar,
		icon: 'icon-calendar-16',
		link: '/calendar',
		parent: TabKey.Tasks,
	},
	BudgetBurnUp: {
		component: ProjectTabBudgetBurnUp,
		icon: 'icon-line-chart-16',
		link: '/burnUp',
		parent: TabKey.Budget,
	},
	BudgetHealth: {
		component: ProjectTabBudgetHealth,
		icon: 'icon-line-chart-16',
		link: '/health',
		parent: TabKey.Budget,
	},
	BudgetBreakdown: {
		component: ProjectTabBudgetBreakdown,
		icon: 'icon-chart-16',
		link: '/breakdown',
		parent: TabKey.Budget,
	},
	BudgetQuotedVsActual: {
		component: ProjectTabBudgetQuotedVsActual,
		icon: 'icon-comparison-16',
		link: '/quotedVsActual',
		parent: TabKey.Budget,
	},
	BudgetProfit: {
		component: ProjectTabBudgetProfit,
		icon: 'icon-coins-16',
		link: '/profit',
		parent: TabKey.Budget,
	},
	RevenueForecast: {
		component: ProjectTabBudgetForecast,
		icon: 'icon-stepchart-16',
		link: '/revenueForecast',
		parent: TabKey.Budget,
	},
};
